import ItemManager from "@/components/admin/ItemManager";

export default function ServicesManager() {
  return (
    <ItemManager
      collection="services"
      title="Pageant Categories"
      subtitle="The pageant categories and programs displayed on the website."
      testidPrefix="service"
      fields={[
        { name: "title", label: "Category Name", type: "text" },
        { name: "age_range", label: "Age Range (e.g. Ages 3 – 12)", type: "text" },
        { name: "description", label: "Description", type: "textarea", rows: 4 },
        { name: "image", label: "Photo", type: "image" },
      ]}
      cardTitle={(i) => i.title}
      cardSubtitle={(i) => i.age_range}
    />
  );
}
